<template>
  <div class="page-body content-inner" data-content-width="wide" v-if="isReady">
    <div class="page-header typography">
      <h1>{{ t("app-program-settings") }}</h1>
    </div>

    <form v-if="isReady" v-on:submit.prevent="save()" class="standard-form-style">


      <table class="vuetable ui-table fixed clickable-rows">
        <thead>
        <tr>
          <th>{{ t("app-name") }}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr @click="program.settings.NQMS = !program.settings.NQMS">
          <td>{{ t("app-nqms") }}</td>
          <td>
            <div class="md-style-scoped">
              <md-switch v-model="program.settings.NQMS"></md-switch>
            </div>
          </td>
        </tr>
        <tr @click="program.settings.ADA = !program.settings.ADA">
          <td>{{ t("app-ada") }}</td>
          <td>
            <div class="md-style-scoped">
              <md-switch v-model="program.settings.ADA"></md-switch>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <program-actions active="settings" :program="program"  />
    </form>

  </div>
</template>

<script lang="ts">
import Program from "Models/program/Program"
import PageMixin from "../../../mixins/PageMixin"
import BaseMixin from "BaseMixin"
import ProgramActions from "../ProgramActions.vue"

export default {
  mixins: [BaseMixin, PageMixin],

  components: {
    ProgramActions
  },

  data() {
    return {
      program: new Program(),
    }
  },

  async mounted() {
    this.app.showLoading()
    if(this.$route.params.id) {
      this.program.document.id = this.$route.params.id
      this.program.settings.id = this.$route.params.id
      await this.program.load()
    }
    this.ready()
  },

  methods: {
    async save() {
      this.app.showLoading()
      await this.program.settings.save()
      await this.router.push(this.link("admin/programs"))
    }
  }
}
</script>

<style lang="scss" scoped>
td:first-child {
  width: 100%
}
.vuetable {
  margin-bottom: 100px
}
</style>